import { render, staticRenderFns } from "./LoginOrGuestDialog.vue?vue&type=template&id=6ae0cc7c&"
import script from "./LoginOrGuestDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginOrGuestDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoginOrGuestDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports